import {
    NCoreUIKitLocalize
} from "../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../types";
import {
    MoreHorizontalIcon,
    ChevronRightIcon,
    ChevronLeftIcon,
    SlashIcon
} from "lucide-react-native";
import {
    getMirrorStyle,
    isMirroredIcon
} from "../../helpers/direction";

export const BreadcrumbBackIcon: NCoreUIKitIcon = ({
    customColor,
    size
}) => {
    const {
        direction
    } = NCoreUIKitLocalize.useContext();

    return <ChevronLeftIcon
        style={getMirrorStyle({
            isMirrored: isMirroredIcon({
                name: "ChevronLeft"
            }),
            direction
        })}
        color={customColor}
        size={size}
    />;
};

export const BreadcrumbChevronIcon: NCoreUIKitIcon = ({
    customColor,
    size
}) => {
    const {
        direction
    } = NCoreUIKitLocalize.useContext();

    return <ChevronRightIcon
        style={getMirrorStyle({
            isMirrored: isMirroredIcon({
                name: "ChevronRight"
            }),
            direction
        })}
        color={customColor}
        size={size}
    />;
};

export const BreadcrumbSlashIcon: NCoreUIKitIcon = ({
    customColor,
    size
}) => <SlashIcon
    color={customColor}
    size={size}
/>;

export const BreadcrumbEllipsisIcon: NCoreUIKitIcon = ({
    customColor,
    size
}) => <MoreHorizontalIcon
    color={customColor}
    size={size}
/>;
